export const DRAFT = 0;
export const CONNECTED = 5;
export const PROTECT = 15;
export const PUBLISH = 20;

const OLD_PROTECT = 1;
const OLD_PUBLIC = 2;
const OLD_PUBLISH = 3;

export const LABEL_DRAFT = "비공개";
export const LABEL_CONNECTED = "친구 공개";
export const LABEL_PROTECT = "공개(보호)";
export const LABEL_PUBLISH = "공개";

export const DESCRIPTION_DRAFT = "작성자만 글을 읽을 수 있습니다";
export const DESCRIPTION_CONNECTED = "나와 친구인 사람만 글을 읽을 수 있습니다";
export const DESCRIPTION_PROTECT = "비밀번호를 아는 사람은 글을 읽을 수 있습니다";
export const DESCRIPTION_PUBLISH = "누구나 글을 읽을 수 있습니다";

export const VisibilityTypes = [
  { value:PUBLISH, label:LABEL_PUBLISH, description:DESCRIPTION_PUBLISH },
  { value:PROTECT, label:LABEL_PROTECT, description:DESCRIPTION_PROTECT },
  { value:CONNECTED, label:LABEL_CONNECTED, description:DESCRIPTION_CONNECTED },
  { value:DRAFT, label:LABEL_DRAFT, description:DESCRIPTION_DRAFT },
];

export const MigrateVisibilityValues = [
  { value:DRAFT, migrateValue:DRAFT },
  { value:OLD_PROTECT, migrateValue:PROTECT },
  { value:OLD_PUBLIC, migrateValue:PUBLISH },
  { value:OLD_PUBLISH, migrateValue:PUBLISH },
  { value:CONNECTED, migrateValue:CONNECTED },
  { value:PROTECT, migrateValue:PROTECT },
  { value:PUBLISH, migrateValue:PUBLISH }
]

